"use client";
import { SubscriptionKeys } from "@/types/subscriptions";
import { emitterEmit } from "@/providers/WebSocketProvider/emitter";

export function subscription({
  key,
  value,
}: {
  key: SubscriptionKeys;
  value: any;
  fetchUrl?: string;
}) {
  emitterEmit(key, value);
  return true;
}
